module.exports = __webpack_public_path__ + "img/icon-shop.b5726df3.svg";